import { render, staticRenderFns } from "./Rate-Lead-Modal.vue?vue&type=template&id=67b68d18&scoped=true"
import script from "./Rate-Lead-Modal.vue?vue&type=script&lang=js"
export * from "./Rate-Lead-Modal.vue?vue&type=script&lang=js"
import style0 from "./Rate-Lead-Modal.vue?vue&type=style&index=0&id=67b68d18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b68d18",
  null
  
)

export default component.exports